'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiEmail = function ApiEmail(Restangular, $http, ApiBaseResponseService) {
    _classCallCheck(this, ApiEmail);

    var factory = {};

    factory.sendMail = function (data) {
        return Restangular.all('emails/send').post(data).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
    };

    factory.resendMail = function (taskId) {
        return Restangular.one('emails/resend', taskId).post().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
    };

    factory.getAttachment = function (id) {
        return Restangular.one('emails/attachments', id).get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
    };

    factory.attachment = function (attachment) {
        return Restangular.all('emails/attachments').withHttpConfig({
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined
            }
        }).customPOST(attachment, undefined, undefined, { 'Content-Type': undefined }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
    };

    return factory;
};

exports.default = ApiEmail;


ApiEmail.inject = ['Restangular', '$http', 'ApiBaseResponseService'];


/** WEBPACK FOOTER **
 ** ./src/app/services/apiEmail.js
 **/